import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=2b65ad04&scoped=true"
import script from "./CompanyIntro.vue?vue&type=script&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&id=2b65ad04&prod&scoped=true&lang=css"
import style1 from "./CompanyIntro.mobile.css?vue&type=style&index=1&id=2b65ad04&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65ad04",
  null
  
)

export default component.exports